import React from 'react'
import Wrapper from './style'

const SchContentContainer = ({children}) => {
	return (
		<Wrapper className={children ? "container" : ""}>
			{children}
		</Wrapper>
	)
}

export default SchContentContainer
